export const USER_SURVEY_REQUEST = "USER_SURVEY_REQUEST";
export const USER_SURVEY_SUCCESS = "USER_SURVEY_SUCCESS";
export const USER_SURVEY_FAIL = "USER_SURVEY_FAIL";
export const USER_SURVEY_CLEAR_ERRORS = "USER_SURVEY_CLEAR_ERRORS";

export const USER_SURVEY_ANS_REQUEST = "USER_SURVEY_ANS_REQUEST";
export const USER_SURVEY_ANS_SUCCESS = "USER_SURVEY_ANS_SUCCESS";
export const USER_SURVEY_ANS_FAIL = "USER_SURVEY_ANS_FAIL";
export const USER_SURVEY_ANS_CLEAR_ERRORS = "USER_SURVEY_ANS_CLEAR_ERRORS";

export const USER_SURVEY_COMP_REQUEST = "USER_SURVEY_COMP_REQUEST";
export const USER_SURVEY_COMP_SUCCESS = "USER_SURVEY_COMP_SUCCESS";
export const USER_SURVEY_COMP_FAIL = "USER_SURVEY_COMP_FAIL";
export const USER_SURVEY_COMP_CLEAR_ERRORS = "USER_SURVEY_COMP_CLEAR_ERRORS";
